export default __webpack_public_path__ + "static/media/vienna-hotel.f1c7347e.png";